__turbopack_context__.v({
  "error": "SignatureSection-module-scss-module__xshC9W__error",
  "signature-canvas": "SignatureSection-module-scss-module__xshC9W__signature-canvas",
});
